module.exports = __webpack_public_path__ + "media/images/screen-shot-2021-02-11-at-4-02-1@1x-0806a3e93473167aa16e32a0bd5d101d.png";